import { createContext, useContext } from "react";
import VerifyAuth from "../services/firebaseActions/verifyAuth";

export const AuthContext = createContext({ isLoggedIn: null });
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const isLoggedIn = VerifyAuth(); 
  return (
    <AuthContext.Provider value={{ isLoggedIn }}>
      {children}
    </AuthContext.Provider>
  );
};
